'use strict'

import ApiClient from './ApiClient'

export default class AnnouncementRepository {
  /**
   * 閲覧可能な運営からのお知らせ一覧を取得します。
   * @returns {*}
   */
  getList () {
    return ApiClient().get(`/announcements`)
  }

  /**
   * 未読の運営からのお知らせ件数を取得します。
   * @returns {*}
   */
  getUnreadCount () {
    return ApiClient().get(`/announcements`, { params: { unread: '1', count: '1' } })
  }

  /**
   * 指定されたIDの運営からのお知らせを取得します。
   * @param {string|int} id 運営からのお知らせID
   */
  get (id) {
    return ApiClient().get(`/announcements/${id}`)
  }

  /**
   * 指定されたIDの運営からのお知らせを既読にします。
   * @param {string|int} id 運営からのお知らせID
   */
  read (id) {
    return ApiClient().put(`/announcements/read/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/AnnouncementRepository.js